class LiteYoutube extends HTMLElement {
  connectedCallback() {
    const videoId = this.getAttribute('video-id');
    if (!videoId) return;

    this.classList.add('rage-lite-youtube');
    this.#loadBestThumbnail(videoId);

    const playButton = document.createElement('button');
    playButton.className = 'rage-lite-youtube__play';
    playButton.type = 'button';
    playButton.setAttribute('aria-label', 'Play video');
    playButton.innerHTML =
      '<svg viewBox="0 0 68 48" width="68" height="48" aria-hidden="true"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="#212121" fill-opacity=".8"></path><path d="M45 24 27 14v20" fill="#fff"></path></svg>';

    playButton.addEventListener('click', () => this.loadVideo());
    this.append(playButton);
  }

  /**
   * YouTube doesn't guarantee a 1280x720 (maxresdefault) thumbnail exists for
   * every video — older or low-res uploads may not have one generated. When it
   * doesn't exist, YouTube still returns a 200 response, but serves a small grey
   * 120x90 placeholder instead of a real 404. We detect that placeholder by its
   * known dimensions and fall back to hqdefault (480x360) when it happens, so we
   * always end up with the best real thumbnail available rather than a stretched
   * low-res image or a blank grey box.
   */
  #loadBestThumbnail(videoId) {
    const highRes = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
    const fallback = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

    const probe = new Image();
    probe.onload = () => {
      const isMissingPlaceholder = probe.naturalWidth === 120 && probe.naturalHeight === 90;
      const bestUrl = isMissingPlaceholder ? fallback : highRes;
      this.style.setProperty('--rage-lite-yt-bg', `url("${bestUrl}")`);
    };
    probe.onerror = () => {
      this.style.setProperty('--rage-lite-yt-bg', `url("${fallback}")`);
    };
    probe.src = highRes;
  }

  loadVideo() {
    const videoId = this.getAttribute('video-id');
    const iframe = document.createElement('iframe');
    iframe.setAttribute(
      'src',
      `https://www.youtube.com/embed/${videoId}?autoplay=1`
    );
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
    );
    iframe.setAttribute('allowfullscreen', '');
    iframe.className = 'rage-lite-youtube__iframe';
    this.textContent = '';
    this.appendChild(iframe);
    this.classList.add('rage-lite-youtube--activated');
  }
}

if (!customElements.get('lite-youtube')) {
  customElements.define('lite-youtube', LiteYoutube);
}
